import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { c_card_calendar_component } from './c_card_calendar.component';
import { SharedModule } from '../../../../../app/directives/shared.module'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
  ],
  declarations: [c_card_calendar_component],
  exports: [c_card_calendar_component],
})
export class c_card_calendar_module { }
